import React, { useState } from 'react'
import { View } from 'react-native'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import {
  BtText,
  BtModal,
  BtButton,
  BtLoading,
} from '@linqpal/components/src/ui'

import { InvoiceWasDeleted } from '../InvoiceWasDeleted'
import { CloseLines } from '../../../../../../assets/icons'
import { styles } from './styles'
import projectsStore from '../../../../Store'

type ModalProps = {
  item: any
  projectId: string
  modalVisible: boolean
  setModalVisible: (a: boolean) => void
}
export const RemoveInvoiceFromProject = observer((props: ModalProps) => {
  const { t } = useTranslation('global')

  const [confirmModalVisible, setConfirmModalVisible] = useState(false)

  const { loadingDelete, setLoadingDelete, removeInvoicesFromProject } =
    projectsStore

  const { item, projectId, modalVisible, setModalVisible } = props

  const close = () => {
    setModalVisible(false)
  }

  const handleSuccess = () => {
    setLoadingDelete(false)
    setModalVisible(false)
    setConfirmModalVisible(true)
  }

  const onRemoveInvoiceSo = () => {
    setLoadingDelete(true)
    removeInvoicesFromProject(projectId, handleSuccess)
  }

  return (
    <>
      <BtModal
        testID={'projects-remove-invoice-modal'}
        visible={modalVisible}
        onClose={close}
        containerStyle={styles.containerStyle}
        onBackdropPress={close}
      >
        <BtButton style={styles.closeButton} onPress={close}>
          <CloseLines height={10} width={10} />
        </BtButton>

        <View style={styles.mainContent}>
          <BtText style={styles.title}>
            {t('Projects.AreYouSureRemoveInvoice')}
          </BtText>

          <BtText style={styles.subtitle}>
            {t('Projects.RemoveInvoiceText')}
          </BtText>

          <View style={styles.footerContainer}>
            <BtButton
              style={styles.deleteBtn}
              disabled={loadingDelete}
              onPress={onRemoveInvoiceSo}
            >
              {loadingDelete ? (
                <BtLoading />
              ) : (
                () => (
                  <BtText style={styles.deleteLabel}>
                    {t('Projects.RemoveInvoiceSo')}
                  </BtText>
                )
              )}
            </BtButton>

            <BtButton style={styles.goBackBtn} onPress={close}>
              <BtText style={styles.goBackLabel}>
                {t('Projects.go_back')}
              </BtText>
            </BtButton>
          </View>
        </View>
      </BtModal>

      <InvoiceWasDeleted
        visible={confirmModalVisible}
        setVisible={setConfirmModalVisible}
        projectName={item?.invoice_number}
      />
    </>
  )
})
